import { FontFamilyTokens, FontSizeTokens, SizeTypeTokens, TextAlignTokens, } from '@voltmoney/schema';
import React, { memo, useEffect, useRef, useState, } from 'react';
import { Animated, Dimensions, FlatList, Image, StyleSheet, View, } from 'react-native';
import Space from '../space/Space';
import Typography from '../typography/Typography';
const Carousal = ({ data, textColor }) => {
    const { height, width } = Dimensions.get('window');
    const [activeIndex, setActiveIndex] = useState(0);
    const scrollX = useRef(new Animated.Value(0)).current;
    const handleOnScroll = (event) => {
        Animated.event([
            {
                nativeEvent: {
                    contentOffset: {
                        x: scrollX,
                    },
                },
            },
        ], {
            useNativeDriver: false,
        })(event);
    };
    useEffect(() => {
        slideRef.current.scrollToOffset({
            animated: true,
            offset: 0,
        });
    }, []);
    const handleOnViewableItemsChanged = useRef(({ viewableItems, changed }) => {
        if (changed && changed.length > 0) {
            setActiveIndex(changed[0].index);
        }
    });
    const viewabilityConfig = useRef({
        waitForInteraction: true,
        viewAreaCoveragePercentThreshold: 60,
    }).current;
    const slideRef = useRef(null);
    const renderFlatListItem = (item, index) => {
        return (React.createElement(View, { style: {
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                paddingHorizontal: 4,
                paddingRight: 14,
                paddingLeft: 10,
            } },
            React.createElement(Image, { source: { uri: item.image }, style: [
                    styles.image,
                    {
                        height: height * 0.5,
                        width: width - 60,
                    },
                ] }),
            React.createElement(Space, { size: SizeTypeTokens.XXXXXXL }),
            React.createElement(View, { key: index, style: styles.typographyContainer },
                React.createElement(Typography, { key: index, label: item.text, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.XXL, color: textColor, fontWeight: '900', textAlign: TextAlignTokens.center }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FlatList, { data: data, renderItem: ({ item, index }) => (React.createElement(React.Fragment, null, renderFlatListItem(item, index))), initialScrollIndex: 0, decelerationRate: 0, renderToHardwareTextureAndroid: true, horizontal: true, bounces: false, pagingEnabled: true, onScroll: handleOnScroll, snapToAlignment: 'center', showsHorizontalScrollIndicator: false, onViewableItemsChanged: handleOnViewableItemsChanged.current, viewabilityConfig: viewabilityConfig, keyExtractor: (item) => item.id, ref: slideRef }),
        React.createElement(Space, { size: SizeTypeTokens.XL }),
        React.createElement(View, { style: {
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: 10,
            } }, data.map((_, i) => {
            const inputRange = [
                (i - 1) * width,
                i * width,
                (i + 1) * width,
            ];
            const opacity = scrollX.interpolate({
                inputRange,
                outputRange: [0.3, 1, 0.5],
                extrapolate: 'clamp',
            });
            return (React.createElement(Animated.View, { key: i.toString(), style: [styles.dots, { opacity: opacity }] }));
        }))));
};
const styles = StyleSheet.create({
    image: {
        justifyContent: 'center',
    },
    typographyContainer: {
        width: '100%',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        bottom: 0,
        marginTop: 60,
    },
    dots: {
        height: 8,
        width: 8,
        borderRadius: 5,
        //TODO use activeIndex to change bg color
        backgroundColor: '#1434CB',
        marginHorizontal: 8,
        margin: 12,
    },
});
// @ts-ignore
export default memo(Carousal);
// @ts-ignore
export { Carousal };
